export default __webpack_public_path__ + "media/images/banner/banner-29-95e24607abaa7f3bbb0e1a5c79330c43.jpg";